import React from 'react';

const ExternalLinkIcon = () => (
  <svg
    width="15"
    height="15"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 8 10"
    enableBackground="new 0 0 8 8"
    xmlSpace="preserve"
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.625,3.5c-0.101,0-0.191-0.041-0.259-0.105C7.364,3.393,7.361,3.393,7.359,3.391  L6.427,2.458l-2.36,2.36c-0.244,0.243-0.64,0.243-0.884,0c-0.244-0.244-0.244-0.64,0-0.884l2.359-2.359L4.609,0.641  C4.607,0.639,4.607,0.636,4.605,0.634C4.541,0.566,4.5,0.476,4.5,0.375C4.5,0.168,4.668,0,4.875,0H7.5C7.776,0,8,0.224,8,0.5v2.625  C8,3.332,7.832,3.5,7.625,3.5z M1,2.25v4.5C1,6.888,1.112,7,1.25,7h4.5C5.888,7,6,6.888,6,6.75V4l1,1v2c0,0.553-0.447,1-1,1H1  C0.448,8,0,7.553,0,7V2c0-0.552,0.448-1,1-1h2l1,1H1.25C1.112,2,1,2.112,1,2.25z"
    />
  </svg>
);

export default ExternalLinkIcon;
